import { MenuItem, Select } from '@material-ui/core'
import React, { useCallback, useState } from 'react'

import { Typography } from '@mui/material'
import { useUpdateBoard } from '../../../api'

interface IBoardStyle {
  boardId: string
  id: string
  disabled: boolean
}

export const BoardStyle = (props: IBoardStyle) => {
  const [id, setId] = useState(props.id)
  const boardStyles = [
    {
      id: 'f59b94d4-f63f-4fd6-9bd2-790d566d84e5',
      title: 'Flagship Black',
      value: 'black'
    },
    {
      id: 'c72f352d-937e-43d7-85e2-d971d06e2e4c',
      title: 'Flagship White',
      value: 'white'
    },
    {
      id: '7908c7fe-587c-4615-92f6-779df8d3caa3',
      title: 'Note Black',
      value: 'note-black'
    },
    {
      id: '63d5cae6-3526-4711-bba3-e63e471a5769',
      title: 'Note White',
      value: 'note-white'
    },
    {
      id: '5d6ced49-af1b-4899-81f0-9135becf8d7a',
      title: 'Flagship Black Heart',
      value: 'flagship-black-heart'
    },
    {
      id: '3ae99299-199e-4f2f-a464-ced530f18956',
      title: 'Flagship White Heart',
      value: 'flagship-white-heart'
    }
  ]
  const [updateBoardMutation] = useUpdateBoard()
  const { boardId } = props

  const updateDevice = useCallback(
    async (boardStyle: string) => {
      setId(boardStyle)

      try {
        await updateBoardMutation({
          variables: {
            input: {
              boardId,
              boardStyle
            }
          }
        })
      } catch (e) {}
    },
    [updateBoardMutation, boardId]
  )

  if (props.id && !boardStyles.find(boardStyle => boardStyle.value === props.id)) {
    return (
      <Typography variant='body2' textTransform='capitalize'>
        {props.id.replace(/-/g, ' ')}
      </Typography>
    )
  }

  return (
    <Select
      disabled={props.disabled}
      variant='outlined'
      value={id}
      onChange={e => {
        updateDevice(e.target.value as string)
      }}>
      <MenuItem></MenuItem>
      {boardStyles.map(boardStyle => (
        <MenuItem key={boardStyle.id} value={boardStyle.value}>
          {boardStyle.title}
        </MenuItem>
      ))}
    </Select>
  )
}
